import {Injectable} from "@angular/core";
import {distinctUntilChanged, filter, first, Observable, ReplaySubject, Subject, takeUntil} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DataSubscriptionService {
  
  private destroy$ = new Subject<void>();
  private destroys$ = new Map<string, Subject<void>>()
  private dataStore: Map<string, Subject<any>> = new Map<string, Subject<any>>();
  
  // Returns every next encountered non-undefined value
  onNext<T>(key: string): Observable<T> {
    this.guard(key);
    return this.dataStore.get(key)!
      .asObservable()
      .pipe(filter(x => x !== undefined))
      .pipe(takeUntil(this.destroy$))
  }
  
  // Returns every next encountered non-undefined 'distinct' value.
  // If multiples of the same value are published, only the first one is passed as an observable.
  // This is based upon memory address. So either re-assign (your only options if its an interface), or implement custom equals()!
  onChanges<T>(key: string): Observable<T> {
    this.guard(key);
    return this.onNext<T>(key)
      .pipe(distinctUntilChanged())
  }
  
  // Completes after the first published non-undefined value after subscription.
  // This means you can subscribe before anything has been published.
  // But it needs a new item to be published in order to be triggered
  onFirst<T>(key: string): Observable<T> {
    this.guard(key);
    return this.onNext<T>(key)
      .pipe(first());
  }
  
  // Returns every next encountered value, both undefined and non-undefined
  onNextNullable<T>(key: string): Observable<T> {
    this.guard(key);
    return this.dataStore.get(key)!
      .asObservable()
      .pipe(takeUntil(this.destroy$))
  }
  
  publish<T>(key: string, value?: T): T | undefined {
    this.guard(key);
    this.dataStore.get(key)!.next(value);
    return value
  }
  
  //Makes sure the key is available as a ReplaySubject.

  unsubscribe(key: string) {
    const subscription = this.destroys$.get(key)!!
    subscription.next()
    subscription.complete()
  }
  
  unsubscribeAll() {
    this.destroy$.next()
    this.destroy$.complete()
    this.dataStore.clear()
  }
  
  //This means you can subscribe to a value before it has been published.
  private guard(key: string) {
    if (!this.dataStore.has(key)) {
      this.dataStore.set(key, new ReplaySubject<any>(1))
    }
    // if (!this.destroys$.has(key)) {
    //   this.destroys$.set(key, new Subject<void>())
    // }
  }
  
}